export default {
    private: false,
    slug: 'viselio',
    promo: 'Viselio saw a 272% increase on Ad Recall Lift by harnessing the power of video ads.',
    meta: {
        title: 'Viselio X Foap  - Case study',
        description: 'Learn how FOAP and Facebook helped Viselio reach an impressive ROAS',
        ogImage: require('Theme/images/videoCaseStudies/viselio/videoCaseStudy-viselio-og.jpg')
    },
    hero: {
        visible: true,
        title: 'Case Study',
        logoHref: 'https://www.viselio.com',
        logo: require('Theme/images/videoCaseStudies/viselio/videoCaseStudy-viselio-logo.png')
    },
    challenge: {
        visible: true,
        title: 'Disrupting inefficiency',
        subtitle: 'All it took was one nightmare visit to a Russian visa office to provide the spark behind <a href="https://www.viselio.com" target="_blank">Viselio</a>. The long and painful process needed to be changed – and fast. Viselio stepped in to offer an online visa application service to reduce processing times and increase application success rates.',
        video: {
            container: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-fbMock-empty.png'),
            poster: require('Theme/images/videoCaseStudies/viselio/videoCaseStudy-viselio-challenge-videoPoster.jpg'),
            assets: [{
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/webm_w640-foap-case-study-viselio-1.webm',
                type: 'video/webm'
            }, {
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/mp4_w640-foap-case-study-viselio-1.mp4',
                type: 'video/mp4'
            }]
        },
        footer: 'The online visa service saw a 272% increase on Ad Recall Lift by harnessing the power of video ads on Facebook to guide a follow-up DPA campaign.',
        float01: require('Theme/images/videoCaseStudies/viselio/videoCaseStudy-viselio-challenge-float01.jpg'),
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-sideBg.svg'),
        ogImage: require('Theme/images/videoCaseStudies/viselio/videoCaseStudy-viselio-og.jpg')
    },
    solutionv2: {
        visible: true,
        title: 'Fishing for ROAS with video',
        subtitle: `
            Viselio wanted to increase engagement around their brand.  
            At the same time, they were curious to see how effective video ads could be in boosting their brand 
            awareness and building a custom audience.
        `,
        photo0: require('Theme/images/videoCaseStudies/viselio/videoCaseStudy-viselio-whyus-photo-00.jpg'),
    },
    solutionv22: {
        visible: true,
        title: 'A first for everything',
        subtitle: `
            In the past, Viselio had achieved good results by using DPAs on Facebook to retarget website visitors. 
            This time around, they decided to change things up a little. It would be a campaign of firsts.
            <br /><br />
            For the first time ever, they decided to use Facebook video ads to really push their brand and grab the imagination 
            of their buyer persona, while also drawing awareness about certain destinations (e.g. India, Russia, Vietnam, and China) 
            and the taxing visa requirements involved. 
            <br /><br />
            It would also be the first time they would work with Foap to generate engaging video ads 
            customized to their specific campaign brief. 
            <br /><br />
            The Foap creative team firstly called upon their global community of photographers to source authentic 
            travel photos from India, Russia, Vietnam, and China. Foap then launched a video Mission, assembling a select 
            group of videographers and motion designers to create fun and engaging animated video ads, drawing on the imagery 
            already generated from the previous photo Mission.
            <br /><br />
            The rest was as quick and easy as Viselio’s visa service. Viselio selected the winning video ads, uploaded 
            them to Facebook and deployed the ads with custom target settings within the key territories of Germany, 
            Switzerland, and Austria.        
        `,
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-whyus-sideBg.svg'),
        photo1: require('Theme/images/videoCaseStudies/viselio/videoCaseStudy-viselio-whyus-photo-01.jpg'),
        photo2: require('Theme/images/videoCaseStudies/viselio/videoCaseStudy-viselio-whyus-photo-02.jpg'),
        photo3: require('Theme/images/videoCaseStudies/viselio/videoCaseStudy-viselio-whyus-photo-03.jpg'),
    },
    resultsv2: {
        visible: true,
        title: 'Double surprise',
        textBlock: `
            Opting for video over static image ads proved to be a big success. The video ads not only delivered Viselio the 
            metrics required for their follow-up DPA campaign but gave them instant results. Over just a 7-day period, their 
            initial campaign recorded:  
        `,
        testimony: {
            title: 'Client testimony:',
            content: `
                “Our whole goal is to open up new and exotic locations for travelers and then ultimately help them to get there. 
                In that spirit, we thought we would also enter new territory. We tested out video ads on Facebook mainly to 
                gather data for our next DPAs. But we didn’t expect to see a 272%  increase in Ad Recall Lift
                over just a week. I mean, it was supposed to be a test run. A very pleasant surprise, to say the least.”
                <br /><br />
                Niklas Zeller, CEO & Co-Founder of Viselio
            `,
        },
        list: [{
            styles: { color: '#4AD2FF' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-graph-lines.svg'),
            title: '272%',
            subtitle: 'increase in Ad Recall Lift'
        }, {
            styles: { color: '#F5A623' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-rocket.svg'),
            title: '-60%',
            subtitle: 'CPM'
        }, {
            styles: { color: '#50E3C2' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-globe.svg'),
            title: '72 000+',
            subtitle: 'Engaged Users'
        }],
        photo2: require('Theme/images/videoCaseStudies/viselio/videoCaseStudy-viselio-results-photo-01.jpg'),
        bgSide: require('Theme/images/videoCaseStudies/videoCaseStudy-results-top.svg')
    },
    checkout: {
        visible: true
    }
};



// WEBPACK FOOTER //
// ./src/containers/global/VideoCaseStudy/data/viselio.js